import { call, put, takeLatest } from "redux-saga/effects";

import {
  GET_CUSTOMER_RECENT_NOTES,
  GOT_CUSTOMER_RECENT_NOTES,
  SAVE_NEW_CUSTOMER_NOTE,
  SAVED_NEW_CUSTOMER_NOTE,
  SAVE_EDIT_CUSTOMER_NOTE,
  SAVED_EDIT_CUSTOMER_NOTE,
  DELETE_CUSTOMER_NOTE,
  DELETED_CUSTOMER_NOTE
} from "../customerNotes";
import { getLocalStorageItem, getOrgId } from "../../utils/helpers";
import { handleApiErrors } from "./helpers";

/***** SAGA START ******/
export let getCustomerRecentNotesApi = payload => {
  let { customerId } = payload.data;
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return handleApiErrors({ generalError: true });
  }
  if (!customerId) {
    logger.error("No customer ID somehow");
    return handleApiErrors({ generalError: true });
  }
  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/${customerId}/notes`,
    {
      headers: { Authorization: getLocalStorageItem("token_authorization") }
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadCustomerRecentNotesWithCustomerId(payload) {
  try {
    const data = yield call(getCustomerRecentNotesApi, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_CUSTOMER_RECENT_NOTES, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let saveNewCustomerNote = payload => {
  let { customerId, newNote } = payload.data;
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return handleApiErrors({ generalError: true });
  }
  if (!customerId) {
    logger.error("No customer ID somehow");
    return handleApiErrors({ generalError: true });
  }
  const request = JSON.stringify({ note: newNote });
  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/${customerId}/notes`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/json"
      },
      method: "POST",
      body: request
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      throw error;
    });
};

function* saveNewCustomerNoteWithPayload(payload) {
  try {
    const data = yield call(saveNewCustomerNote, payload);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: SAVED_NEW_CUSTOMER_NOTE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let editCustomerNote = payload => {
  let { customerId, noteId, newNote } = payload.data;
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return handleApiErrors({ generalError: true });
  }
  if (!customerId || !noteId) {
    logger.error("Missing IDs");
    return;
  }
  const request = JSON.stringify({ note: newNote });
  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/${customerId}/notes/${noteId}`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/json"
      },
      method: "PUT",
      body: request
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      throw error;
    });
};

function* saveEditCustomerNoteWithPayload(payload) {
  try {
    const data = yield call(editCustomerNote, payload);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: SAVED_EDIT_CUSTOMER_NOTE, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let deleteCustomerNote = payload => {
  let { customerId, noteId } = payload.data;
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return handleApiErrors({ generalError: true });
  }
  if (!customerId || !noteId) {
    logger.error("Missing IDs");
    return handleApiErrors({ generalError: true });
  }
  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/${customerId}/notes/${noteId}`,
    {
      headers: { Authorization: getLocalStorageItem("token_authorization") },
      method: "DELETE"
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      throw error;
    });
};

function* deleteCustomerNoteWithPayload(payload) {
  try {
    const data = yield call(deleteCustomerNote, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({
        type: DELETED_CUSTOMER_NOTE,
        data: { noteId: payload.data.noteId }
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

function* watchRequests() {
  yield* [
    takeLatest(
      GET_CUSTOMER_RECENT_NOTES,
      loadCustomerRecentNotesWithCustomerId
    ),
    takeLatest(SAVE_NEW_CUSTOMER_NOTE, saveNewCustomerNoteWithPayload),
    takeLatest(SAVE_EDIT_CUSTOMER_NOTE, saveEditCustomerNoteWithPayload),
    takeLatest(DELETE_CUSTOMER_NOTE, deleteCustomerNoteWithPayload)
  ];
}

export default [watchRequests];
